import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Dropdown, Modal } from 'react-bootstrap'

import { httpOk, GET, POST, PUT } from 'helpers/api'

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [showModal, setShowModal] = useState(false)

	async function getData() {
		const response = await GET("/departments", {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	async function createUpdate(e) {
		e.preventDefault()
		var response
		if (selectedItem.id) {
			response = await PUT('/departments', selectedItem, { loader: true })
		} else {
			response = await POST('/departments', selectedItem, { loader: true })
		}
		if (httpOk(response)) {
			toggleModal(false)
			getData()
		}
	}

	function toggleModal(bool, item = {}) {
		if (bool) setSelectedItem({ ...item })
		else setSelectedItem({})
		setShowModal(bool)
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">Bo'limlar [{data.length}]</h4>
				<button className="btn-rounded btn btn-primary" onClick={() => toggleModal(true)}>
					<i className="uil-plus me-1"></i>{t('create')}
				</button>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ minWidth: '33px' }} className="text-center">#</th>
									<th>{t('name2')}</th>
									<th style={{ minWidth: '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td className="fw-semibold">{item.name}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>
													<Dropdown.Menu>
														<div className="table-dropdown-item" onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>{t('edit')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* CREATE/EDIT MODAL */}
			<Modal show={showModal} animation={false} centered backdrop="static"
				onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ? "Bo'lim yaratish" : "Bo'limni tahrirlash"}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group mb-0">
							<label>Bo'lim nomi<span className="required-mark">*</span></label>
							<input type="text" className="form-control" autoFocus
								placeholder="Masalan: Profnastil, Tunukafon, Sotuv bo'limi"
								value={selectedItem.name ?? ""}
								onChange={(e) => setSelectedItem({ ...selectedItem, name: e.target.value })}
								required />
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Index
